import api from "@others/api.ts"

import { Endpoints } from "@constants/Endpoints.tsx"
import { AppFunctions } from "@others/AppFunctions.ts"
import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { PostBookSpaceAdapter } from "@adapters/PostBookSpaceAdapter.ts"
import { IPostBookSpaceBodyApi } from "@interfaces/IPostBookSpaceBodyApi.ts"
import { GetSpaceAllPlacesAdapter } from "@adapters/GetSpaceAllPlacesAdapter.ts"
import { IPostBookSpaceResponseCli } from "@interfaces/IPostBookSpaceResponseCli.ts"
import { IPostBookSpaceResponseApi } from "@interfaces/IPostBookSpaceResponseApi.ts"
import { PostBookRestaurantAdapter } from "@adapters/PostBookRestaurantAdapter.ts"
import { IPostBookRestaurantBodyApi } from "@interfaces/IPostBookRestaurantBodyApi.ts"
import { GetSpaceAvailableDaysAdapter } from "@adapters/GetSpaceAvailableDaysAdapter.ts"
import { GetRestaurantAllPlacesAdapter } from "@adapters/GetRestaurantAllPlacesAdapter.ts"
import { GetSpaceAvailableHoursAdapter } from "@adapters/GetSpaceAvailableHoursAdapter.ts"
import { IGetSpaceAllPlacesResponseApi } from "@interfaces/IGetSpaceAllPlacesResponseApi.ts"
import { IGetSpaceAllPlacesResponseCli } from "@interfaces/IGetSpaceAllPlacesResponseCli.ts"
import { IPostBookRestaurantResponseCli } from "@interfaces/IPostBookRestaurantResponseCli.ts"
import { IPostBookRestaurantResponseApi } from "@interfaces/IPostBookRestaurantResponseApi.ts"
import { IGetSpaceAvailableDaysParamsApi } from "@interfaces/IGetSpaceAvailableDaysParamsApi.ts"
import { IGetSpaceAvailableHoursParamsApi } from "@interfaces/IGetSpaceAvailableHoursParamsApi.ts"
import { IGetSpaceAvailableDaysResponseApi } from "@interfaces/IGetSpaceAvailableDaysResponseApi.ts"
import { IGetSpaceAvailableDaysResponseCli } from "@interfaces/IGetSpaceAvailableDaysResponseCli.ts"
import { GetRestaurantAvailableDaysAdapter } from "@adapters/GetRestaurantAvailableDaysAdapter.ts"
import { IGetSpaceAvailableHoursResponseCli } from "@interfaces/IGetSpaceAvailableHoursResponseCli.ts"
import { IGetSpaceAvailableHoursResponseApi } from "@interfaces/IGetSpaceAvailableHoursResponseApi.ts"
import { IGetRestaurantAllPlacesResponseCli } from "@interfaces/IGetRestaurantAllPlacesResponseCli.ts"
import { IGetRestaurantAllPlacesResponseApi } from "@interfaces/IGetRestaurantAllPlacesResponseApi.ts"
import { GetRestaurantAvailableHoursAdapter } from "@adapters/GetRestaurantAvailableHoursAdapter.ts"
import { IGetRestaurantAvailableDaysParamsApi } from "@interfaces/IGetRestaurantAvailableDaysParamsApi.ts"
import { GetRestaurantAvailableCapacityAdapter } from "@adapters/GetRestaurantAvailableCapacityAdapter.ts"
import { IGetRestaurantAvailableHoursParamsApi } from "@interfaces/IGetRestaurantAvailableHoursParamsApi.ts"
import { IGetRestaurantAvailableDaysResponseCli } from "@interfaces/IGetRestaurantAvailableDaysResponseCli.ts"
import { IGetRestaurantAvailableDaysResponseApi } from "@interfaces/IGetRestaurantAvailableDaysResponseApi.ts"
import { IGetRestaurantAvailableHoursResponseCli } from "@interfaces/IGetRestaurantAvailableHoursResponseCli.ts"
import { IGetRestaurantAvailableHoursResponseApi } from "@interfaces/IGetRestaurantAvailableHoursResponseApi.ts"
import { IGetRestaurantAvailableCapacityParamsApi } from "@interfaces/IGetRestaurantAvailableCapacityParamsApi.ts"
import { IGetRestaurantAvailableCapacityResponseCli } from "@interfaces/IGetRestaurantAvailableCapacityResponseCli.ts"
import { IGetRestaurantAvailableCapacityResponseApi } from "@interfaces/IGetRestaurantAvailableCapacityResponseApi.ts"

const getSpaceAllPlaces = async (): Promise<IGetSpaceAllPlacesResponseCli> => {
	return api
		.get<IApiResponse<IGetSpaceAllPlacesResponseApi>>(
			Endpoints.bookSpaceAllPlaces
		)
		.then(({ data }) => GetSpaceAllPlacesAdapter(data))
		.catch((error) => {
			throw AppFunctions.getErrorApiDetail(error)
		})
}

const getSpaceAvailableDays = async (
	params: IGetSpaceAvailableDaysParamsApi
): Promise<IGetSpaceAvailableDaysResponseCli> => {
	return api
		.get<IApiResponse<IGetSpaceAvailableDaysResponseApi>>(
			Endpoints.bookSpaceAvailableDays,
			{ params }
		)
		.then(({ data }) => GetSpaceAvailableDaysAdapter(data))
		.catch((error) => {
			throw AppFunctions.getErrorApiDetail(error)
		})
}

const getSpaceAvailableHours = async (
	params: IGetSpaceAvailableHoursParamsApi
): Promise<IGetSpaceAvailableHoursResponseCli> => {
	return api
		.get<IApiResponse<IGetSpaceAvailableHoursResponseApi>>(
			Endpoints.bookSpaceAvailableHours,
			{ params }
		)
		.then(({ data }) => GetSpaceAvailableHoursAdapter(data))
		.catch((error) => {
			throw AppFunctions.getErrorApiDetail(error)
		})
}

const bookSpace = async (
	body: IPostBookSpaceBodyApi
): Promise<IPostBookSpaceResponseCli> => {
	return api
		.post<IApiResponse<IPostBookSpaceResponseApi>>(
			Endpoints.bookSpace,
			body
		)
		.then(({ data }) => PostBookSpaceAdapter(data))
		.catch((error) => {
			throw AppFunctions.getErrorApiDetail(error)
		})
}

const getRestaurantAllPlaces =
	async (): Promise<IGetRestaurantAllPlacesResponseCli> => {
		return api
			.get<IApiResponse<IGetRestaurantAllPlacesResponseApi>>(
				Endpoints.bookRestaurantAllPlaces
			)
			.then(({ data }) => GetRestaurantAllPlacesAdapter(data))
			.catch((error) => {
				throw AppFunctions.getErrorApiDetail(error)
			})
	}

const getRestaurantAvailableDays = async (
	params: IGetRestaurantAvailableDaysParamsApi
): Promise<IGetRestaurantAvailableDaysResponseCli> => {
	return api
		.get<IApiResponse<IGetRestaurantAvailableDaysResponseApi>>(
			Endpoints.bookRestaurantAvailableDays,
			{ params }
		)
		.then(({ data }) => GetRestaurantAvailableDaysAdapter(data))
		.catch((error) => {
			throw AppFunctions.getErrorApiDetail(error)
		})
}

const getRestaurantAvailableHours = async (
	params: IGetRestaurantAvailableHoursParamsApi
): Promise<IGetRestaurantAvailableHoursResponseCli | null> => {
	return api
		.get<IApiResponse<IGetRestaurantAvailableHoursResponseApi>>(
			Endpoints.bookRestaurantAvailableHours,
			{ params }
		)
		.then(({ data }) => GetRestaurantAvailableHoursAdapter(data))
		.catch((error) => {
			throw AppFunctions.getErrorApiDetail(error)
		})
}

const getRestaurantAvailableCapacity = async (
	params: IGetRestaurantAvailableCapacityParamsApi
): Promise<IGetRestaurantAvailableCapacityResponseCli | null> => {
	return api
		.get<IApiResponse<IGetRestaurantAvailableCapacityResponseApi>>(
			Endpoints.bookRestaurantAvailableCapacity,
			{ params }
		)
		.then(({ data }) => GetRestaurantAvailableCapacityAdapter(data))
		.catch((error) => {
			throw AppFunctions.getErrorApiDetail(error)
		})
}

const bookRestaurant = async (
	body: IPostBookRestaurantBodyApi
): Promise<IPostBookRestaurantResponseCli> => {
	return api
		.post<IApiResponse<IPostBookRestaurantResponseApi>>(
			Endpoints.bookRestaurant,
			body
		)
		.then(({ data }) => PostBookRestaurantAdapter(data))
		.catch((error) => {
			throw AppFunctions.getErrorApiDetail(error)
		})
}

export default {
	getSpaceAllPlaces,
	getSpaceAvailableDays,
	getSpaceAvailableHours,
	bookSpace,

	getRestaurantAllPlaces,
	getRestaurantAvailableDays,
	getRestaurantAvailableHours,
	getRestaurantAvailableCapacity,
	bookRestaurant,
}
